module.exports = __webpack_public_path__ + "img/dayBG.dd1f934d.png";